export enum EMBEDDED {
    FALSE = 0,
    TRUE = 1,
}
